import { Quote } from "lucide-react";

const QUOTES = [
  ["Small steps every day add up to big changes.", "Unknown"],
  ["You don't have to see the whole staircase, just take the first step.", "Martin Luther King Jr."],
  ["Keep your face always toward the sunshine, and shadows will fall behind you.", "Walt Whitman"],
  ["What you do today can improve all your tomorrows.", "Ralph Marston"],
  ["Happiness is not something ready made. It comes from your own actions.", "Dalai Lama"],
  ["Believe you can and you're halfway there.", "Theodore Roosevelt"],
  ["The secret of getting ahead is getting started.", "Mark Twain"],
  ["Every day may not be good, but there is something good in every day.", "Alice Morse Earle"],
  ["Act as if what you do makes a difference. It does.", "William James"],
  ["It always seems impossible until it's done.", "Nelson Mandela"],
  ["Start where you are. Use what you have. Do what you can.", "Arthur Ashe"],
  ["Nothing is impossible. The word itself says 'I'm possible'!", "Audrey Hepburn"],
  ["Wherever you go, no matter what the weather, always bring your own sunshine.", "Anthony J. D'Angelo"],
  ["The best way to predict the future is to create it.", "Peter Drucker"],
  ["You are never too old to set another goal or to dream a new dream.", "C. S. Lewis"],
  ["Be gentle with yourself, you're doing the best you can.", "Unknown"],
  ["Little by little, one travels far.", "J. R. R. Tolkien"],
  ["Do what you can, with what you have, where you are.", "Theodore Roosevelt"],
  ["Home is where love resides, memories are created, and laughter never ends.", "Unknown"],
  ["The only way to do great work is to love what you do.", "Steve Jobs"],
  ["A calm mind brings inner strength and self-confidence.", "Dalai Lama"],
  ["You are capable of amazing things.", "Unknown"],
  ["Progress, not perfection.", "Unknown"],
  ["Each morning we are born again. What we do today matters most.", "Buddha"],
  ["The sun himself is weak when he first rises, and gathers strength as the day gets on.", "Charles Dickens"],
  ["With the new day comes new strength and new thoughts.", "Eleanor Roosevelt"],
  ["Don't watch the clock; do what it does. Keep going.", "Sam Levenson"],
  ["Gratitude turns what we have into enough.", "Aesop"],
  ["Simplicity is the ultimate sophistication.", "Leonardo da Vinci"],
  ["Breathe. You're going to be okay.", "Unknown"],
  ["A journey of a thousand miles begins with a single step.", "Lao Tzu"],
  ["Doubt kills more dreams than failure ever will.", "Suzy Kassem"],
  ["Life is 10% what happens to us and 90% how we react to it.", "Charles R. Swindoll"],
  ["The best time for new beginnings is now.", "Unknown"],
  ["Kindness is a language which the deaf can hear and the blind can see.", "Mark Twain"],
  ["Your only limit is your mind.", "Unknown"],
  ["Rest when you're weary. Refresh and renew yourself.", "Ralph Marston"],
  ["Happiness is a direction, not a place.", "Sydney J. Harris"],
  ["Hope is a waking dream.", "Aristotle"],
  ["Dream big and dare to fail.", "Norman Vaughan"],
  ["Order and simplification are the first steps toward mastery of a subject.", "Thomas Mann"],
  ["You can't use up creativity. The more you use, the more you have.", "Maya Angelou"],
  ["Optimism is the faith that leads to achievement.", "Helen Keller"],
  ["There is no place more delightful than one's own fireside.", "Cicero"],
  ["Inhale the future, exhale the past.", "Unknown"],
  ["You are allowed to be both a masterpiece and a work in progress.", "Sophia Bush"],
  ["What we think, we become.", "Buddha"],
  ["Tough times never last, but tough people do.", "Robert H. Schuller"],
  ["Make each day your masterpiece.", "John Wooden"],
  ["Keep going. Everything you need will come to you at the perfect time.", "Unknown"],
  ["The power of finding beauty in the humblest things makes home happy.", "Louisa May Alcott"],
  ["One day or day one. You decide.", "Unknown"],
  ["The happiness of your life depends upon the quality of your thoughts.", "Marcus Aurelius"],
  ["Be the reason someone smiles today.", "Unknown"],
  ["In the middle of every difficulty lies opportunity.", "Albert Einstein"],
  ["Slow progress is still progress.", "Unknown"],
  ["Peace begins with a smile.", "Mother Teresa"],
  ["Today is a good day to have a good day.", "Unknown"],
  ["Well done is better than well said.", "Benjamin Franklin"],
  ["You have within you right now, everything you need to deal with whatever the world can throw at you.", "Brian Tracy"],
];

const todaysQuote = () => {
  const d = new Date();
  const day = Math.floor((Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) - Date.UTC(2024, 0, 1)) / 86400000);
  return QUOTES[day % QUOTES.length];
};

export const DailyQuote = () => {
  const [text, author] = todaysQuote();
  return (
    <figure className="mt-8 pl-4 border-l-2 border-t-primary-light/70 max-w-xl fade-up" data-testid="daily-quote">
      <Quote className="h-4 w-4 text-t-primary-light mb-2" />
      <blockquote className="font-serif-display italic text-lg sm:text-xl leading-snug text-white/95" data-testid="daily-quote-text">
        {text}
      </blockquote>
      <figcaption className="text-xs tracking-[0.2em] uppercase text-white/60 mt-2" data-testid="daily-quote-author">— {author}</figcaption>
    </figure>
  );
};
